import type { HandoffApi } from '@/utils/sessionHandoff'

// finnecto-api PLA-396 (#4882), on this build's own VITE_API_URL, so a code only redeems in its region.
const ISSUE_PATH = 'api/auth/session-handoff/'
const REDEEM_PATH = 'api/auth/session-handoff/redeem/'

/** Bounds every call: the router guard awaits the redeem before the first navigation. */
const REQUEST_TIMEOUT_MS = 5000

/** The JSON object of a 2xx response; null on a non-2xx, an unparsable body, a network error or the timeout. */
async function postJson(path: string, body: object, headers: Record<string, string> = {}): Promise<Record<string, unknown> | null> {
  try {
    const response = await fetch(`${import.meta.env.VITE_API_URL}/${path}`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...headers },
      body: JSON.stringify(body),
      signal: AbortSignal.timeout(REQUEST_TIMEOUT_MS),
    })
    if (!response.ok) return null
    const json: unknown = await response.json()
    return typeof json === 'object' && json !== null ? (json as Record<string, unknown>) : null
  } catch {
    return null
  }
}

/** fetch, not HttpClient: redeem runs before Pinia exists, and a refused code must not trigger the 401 logout. */
export const httpSessionHandoffApi: HandoffApi = {
  bearer: async () => {
    // Dynamic: authToken -> logout -> router -> sessionHandoff would be an import cycle.
    const { getBearerToken } = await import('@/utils/authToken')
    return getBearerToken()
  },
  issue: async (entries, bearer) => {
    const body = await postJson(ISSUE_PATH, { entries }, { Authorization: `Bearer ${bearer}` })
    return typeof body?.code === 'string' && body.code !== '' ? body.code : null
  },
  redeem: async (code) => {
    const body = await postJson(REDEEM_PATH, { code })
    return typeof body?.entries === 'object' && body.entries !== null ? (body.entries as Record<string, unknown>) : null
  },
}
